

export default function(to, from, savedPosition) {
        return new Promise((resolve) => {
          if (to.hash) {
            const checkElement = (retries = 30) => {
              const element = document.querySelector(to.hash);
              if (element) {
                const position =
                element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: position, behavior: 'smooth' });
                resolve();
              } else if (retries > 0) {
                setTimeout(() => checkElement(retries - 1), 200);
              } else {
                resolve({ x: 0, y: 0 });
              }
            };
            checkElement();
          }
        });
      }
